import * as Slider from '@radix-ui/react-slider';
import { Flex, SliderProps, Text } from '@radix-ui/themes';
import { CommonInputLabel } from 'components/common/form/label';
import { CommonInputWrapper } from 'components/common/form/wrapper';
import { IInputWrapper } from 'interfaces/forms/_base';
import { round } from 'lib_ts/classes/math.utilities';
import { RADIX } from 'lib_ts/enums/radix-ui';
import './index.scss';

interface IDualSliderInput extends SliderProps, IInputWrapper {
  id: string;
  label?: string;
  roundTo: number;
  // optionally transform the value for display purposes (e.g. for unit conversion)
  transform?: (val: number) => number;
}

export const CommonDualSlider = (props: IDualSliderInput) => {
  const { roundTo, transform: transformFn, ...sliderProps } = props;

  if (!sliderProps.value) {
    return null;
  }

  const range =
    props.value?.map((value) => {
      const v = transformFn ? transformFn(value) : value;
      return round(v, roundTo);
    }) || [];

  return (
    <CommonInputWrapper {...props}>
      <CommonInputLabel {...props} />

      <Slider.Root className="DualSlider" {...sliderProps}>
        <Slider.Track className="DualSliderTrack">
          <Slider.Range className="DualSliderRange" />
        </Slider.Track>
        <Slider.Thumb className="DualSliderThumb" />
        <Slider.Thumb className="DualSliderThumb" />
      </Slider.Root>
      <Flex justify="between">
        <Text size={RADIX.TEXT.SIZE.SM}>{range[0]}</Text>
        <Text size={RADIX.TEXT.SIZE.SM}>{range[1]}</Text>
      </Flex>
    </CommonInputWrapper>
  );
};
